export default "__VITE_ASSET__CSZvrJYc__"